import { buildMessage, ValidateBy, ValidationOptions } from 'class-validator';

export const IsValidDate = (validationOptions?: ValidationOptions): PropertyDecorator =>
  ValidateBy(
    {
      name: 'is-valid-date',
      validator: {
        defaultMessage: buildMessage((eachPrefix) => `${eachPrefix}$property is not a valid date`, validationOptions),
        validate: (value: unknown) => value instanceof Date && !Number.isNaN(+value),
      },
    },
    validationOptions
  );
